import { AppSpan, AppText, CustomContainer, FlexRow, GridContainer } from "src/style";
import {ReactComponent as ActiveIcon} from 'src/assets/svg/active-status-icon.svg'
import {ReactComponent as SuspendedIcon} from 'src/assets/svg/suspended-status-icon.svg'
import helpers from "../helpers";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Dropdown } from "src/component";
import { getRoles } from "@testing-library/react";

function handleDateFormat (datetime: string) {
    if (datetime) {
        let formatedDateTime = helpers.splitDateTime(datetime)
        return `${formatedDateTime?.date} ${formatedDateTime?.time}`
    }
    else return ''
}

export const customersColumn = [
    {
        name: 'User ID',
        selector:(row: any) => row.id,
        minWidth: '20rem',
        wrap: true
    },
    {
        name: 'First Name',
        selector:(row: any) => row.firstName,
        minWidth: '15rem',
        wrap: true
    },
    {
        name: 'Last Name',
        selector:(row: any) => row.lastName,
        minWidth: '15rem',
        wrap: true
    },
    {
        name: 'Email',
        selector:(row: any) => row.emailAddress,
        wrap: true,
        minWidth: '20rem',
    },
    {
        name: 'Phone Number',
        selector:(row: any) => row.mobileNo,
        minWidth: '15rem',
    },
    {
        name: 'Platform',
        selector:(row: any) => row.platform
    },
    {
        name: 'Date Created',
        selector:(row: any) => handleDateFormat(row.dateCreated),
        wrap: true,
        minWidth: '20rem',
    },
    {
        name: 'Status',
        minWidth: '15rem',
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit="" minHeight='2.7'
                minWidth = '9.6'
                bgColor={row.verificationStatus === 'VERIFIED' ? '#D9FFE9' : '#FFF4D2'} 
                topPadding='0' bottomPadding='0' padding='0.8' radius='1.35'
            >
                <AppSpan 
                    color={row.verificationStatus === 'VERIFIED' ? '#27AE60' : '#CAA32E'} 
                    fontWeight='500'
                >
                    {row.verificationStatus}
                </AppSpan>
            </GridContainer>
        ),
    }
]

export const customersData = [
    {
        userId: 4223,
        firstName: 'Ridwan',
        lastName: 'Kolawole',
        email: 'olaniyi.jibola152@gmail.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Verified'
    },
    {
        userId: 4224,
        firstName: 'Damilare',
        lastName: 'Odueso',
        email: 'dami@crendly.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Unverified'
    },
    {
        userId: 4225,
        firstName: 'Ridwan',
        lastName: 'Kolawole',
        email: 'olaniyi.jibola152@gmail.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Verified'
    },
    {
        userId: 4226,
        firstName: 'Ridwan',
        lastName: 'Kolawole',
        email: 'olaniyi.jibola152@gmail.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Verified'
    },
    {
        userId: 4227,
        firstName: 'Damilare',
        lastName: 'Odueso',
        email: 'dami@crendly.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Unverified'
    },
    {
        userId: 4228,
        firstName: 'Ridwan',
        lastName: 'Kolawole',
        email: 'olaniyi.jibola152@gmail.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Verified'
    },
    {
        userId: 4226,
        firstName: 'Ridwan',
        lastName: 'Kolawole',
        email: 'olaniyi.jibola152@gmail.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Verified'
    },
    {
        userId: 4227,
        firstName: 'Damilare',
        lastName: 'Odueso',
        email: 'dami@crendly.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Unverified'
    },
    {
        userId: 4228,
        firstName: 'Ridwan',
        lastName: 'Kolawole',
        email: 'olaniyi.jibola152@gmail.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Verified'
    },
    {
        userId: 4226,
        firstName: 'Ridwan',
        lastName: 'Kolawole',
        email: 'olaniyi.jibola152@gmail.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Verified'
    },
    {
        userId: 4227,
        firstName: 'Damilare',
        lastName: 'Odueso',
        email: 'dami@crendly.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Unverified'
    },
    {
        userId: 4228,
        firstName: 'Ridwan',
        lastName: 'Kolawole',
        email: 'olaniyi.jibola152@gmail.com',
        phoneNumber: '07067231263',
        platform: 'Crendly',
        dateCreated: '2024-02-14T09:20:30Z',
        status: 'Verified'
    }
]


export const addressColumn = [
    {
        name: 'Time Logged',
        selector:(row: any) => typeof(row.createdOnDate) === 'string' ? handleDateFormat(row.createdOnDate) : null,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: 'Geo Location',
        selector:(row: any) => row.address,
        wrap: true,
        minWidth: '20rem',
    },
    {
        name: 'Longitude',
        selector:(row: any) => row.longitude,
    },
    {
        name: 'Latitude',
        selector:(row: any) => row.latitude,
    },
    {
        name: 'Device Type',
        selector:(row: any) => row.channel,
        minWidth: '12rem',
    },
    {
        name: 'Platform',
        selector:(row: any) => row.platform,
        minWidth: '12rem',
    },
    // {
    //     name: 'Last Login',
    //     selector:(row: any) => handleDateFormat(row.lastLogin),
    //     wrap: true,
    //     minWidth: '15rem',
    // },
    {
        name: 'IP Address',
        selector:(row: any) => row.ipAddress,
        minWidth: '14rem',
    },
]

export const addressData = () => {
    const data = {
        timeLogged: '2024-02-14T09:20:30Z',
        geoLocation: '5 Kola Biso Street, Ogba, Lagos',
        longitude: '9.8772671',
        latitude: '3.8772671',
        deviceType: 'Android',
        lastLogin: '2024-02-14T09:20:30Z',
        ipAddress: '223.112.112'
    }

    return helpers.duplicateMockData(data, 10)
}

export const usersColumn = (handleAction: any) => {
    return [
        {
            name: 'ID',
            selector:(row: any) => row.id,
            wrap: true,
            minWidth: '25rem',
        },
        {
            name: 'Display Name',
            selector:(row: any) => `${row.firstName} ${row.lastName}`,
            wrap: true,
            minWidth: '25rem',
        },
        {
            name: 'Email',
            selector:(row: any) => row.email,
            wrap: true,
            minWidth: '22rem',
        },
        {
            name: 'Phone Number',
            selector:(row: any) => row.phoneNumber,
            wrap: true,
            minWidth: '15rem',
        },
        {
            name: 'User Role',
            selector:(row: any) => row.role?.name || (row.hasAccess ? 'CRUD' : 'READ'),
            wrap: true,
            minWidth: '15rem',
        },
        {
            name: '',
            right: true,
            selector:(row: any) => 
            <Dropdown 
                trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#111111' />}
                options={[
                    {value: 'edit', label: 'Edit User'},
                    {value: 'revoke', label: 'Revoke Admin access'}
                ]}
                onSelect={(value: string) => handleAction(row, value)}
            />
        }
    ]
}


export const usersData = () => {
    const data = {
        name: "Ridwan Kolawole",
        username: "Rhydhur",
        email: "olaniyi.jibola152@gmail.com",
        phoneNumber: "07087152712",
        userRole: "Verification Access"
    }

    return helpers.duplicateMockData(data, 3)
}


export const subsidiariesColumn = (clickable = true, handleAction?: any) => [
    {
        name: 'Company Name',
        selector:(row: any) => row.subsidiary?.name,
        wrap: true,
        minWidth: '17rem',
    },
    {
        name: 'No. Of Customers',
        selector:(row: any) => row.noOfCustomers,
        wrap: true,
        minWidth: '12rem',
    },
    {
        name: 'Verified Customers',
        selector:(row: any) => row.noOfVerifiedCustomers,
        wrap: true,
        minWidth: '12rem',
    },
    {
        name: 'Unverfied Customers',
        selector:(row: any) => row.noOfUnVerifiedCustomers,
        wrap: true,
        minWidth: '12rem',
    },
    (clickable ? {
        name: '',
        right: true,
        selector:(row: any) => 
        <Dropdown 
            trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#111111' />}
            options={[
                {value: 'view', label: 'View Subsidiary'},
                {value: 'view-customers', label: 'View Customers'},
                //{value: 'email', label: 'Email Admin'}
            ]}
            onSelect={(value: string) => handleAction(row, value)}
        />
    } : {})
]

export const subsidiariesData = () => {
    const data = {
        subsidiary: {
            name: 'Humexid Tech',
            active: true
        },
        companyName: "Humexid Tech",
        noOfCustomers: "52,000,000",
        noOfVerifiedCustomers: "42,000,000",
        noOfUnVerifiedCustomers: "10,000,000"
    }

    return helpers.duplicateMockData(data, 3)
}

export const companiesColumn = (onAction: any) => [
    {
        name: 'Company Name',
        selector:(row: any) => row.name,
        wrap: true,
        minWidth: '17rem',
    },
    {
        name: 'No. Of Subsidiaries',
        selector:(row: any) => row.hasSubsidiaries ? row.noOfSubsidiaries : 0,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: 'Subscription Plan',
        selector:(row: any) => row.subscriptionPlan,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: 'Subscription Time',
        selector:(row: any) => row.subscriptionTime,
        wrap: true,
        minWidth: '17rem',
    },
    {
        name: 'Status',
        selector:(row: any) => 
            <FlexRow gap="0.5" width="auto" sizeUnit="">
                <AppText 
                    color='#6E7985' 
                >
                    {!row.suspension ? 'Active' : 'Suspended'}
                </AppText>
                { !row.suspension ?
                    <ActiveIcon className="icon-component" />
                    : <SuspendedIcon className="icon-component" />
                }
            </FlexRow>
    },
    {
        name: '',
        right: true,
        selector:(row: any) => 
        <Dropdown 
            trigger={<BsThreeDotsVertical fontSize='1.6rem' color='#111111' />}
            options={[
                {value: 'view', label: 'View Company'},
                {value: row.suspension ? 'unsuspend' : 'suspend', label: `${row.suspension ? 'Unsuspend' : 'Suspend'} Company`}
            ]}
            onSelect={(value: string) => onAction(row, value)}
        />
    }
]

export const companiesData = [
    {
        name: "Humexid Tech",
        noOfSubsidiaries: "15",
        subscriptionPlan: 'Paid',
        subscriptionTime: '1 year',
        subscriptionStatus: 'Active'
    },
    {
        name: "Humexid Tech",
        noOfSubsidiaries: "15",
        subscriptionPlan: 'Paid',
        subscriptionTime: '1 year',
        subscriptionStatus: 'Active'
    },
    {
        name: "Humexid Tech",
        noOfSubsidiaries: "15",
        subscriptionPlan: 'Paid',
        subscriptionTime: '1 year',
        subscriptionStatus: 'Suspended'
    },
    {
        name: "Humexid Tech",
        noOfSubsidiaries: "15",
        subscriptionPlan: 'Paid',
        subscriptionTime: '6 months',
        subscriptionStatus: 'Active'
    },
    {
        name: "Humexid Tech",
        noOfSubsidiaries: "15",
        subscriptionPlan: 'Paid',
        subscriptionTime: '1 year',
        subscriptionStatus: 'Suspended'
    },
    {
        name: "Humexid Tech",
        noOfSubsidiaries: "15",
        subscriptionPlan: 'Paid',
        subscriptionTime: '1 year',
        subscriptionStatus: 'Suspended'
    },
]